<script setup lang="ts">
defineProps<{
  amountLabel: string;
  bankAccountLabel: string | null;
  agencyAccountLabel: string | null;
  differentAccount: boolean;
  isNewAccount: boolean;
}>();

type Emits = {
  toggleModalInner: [];
};

const emit = defineEmits<Emits>();
</script>

<template>
  <div class="deposit-approved text-center">
    <div
      class="flex flex-row items-center gap-3 cursor-pointer mb-4"
      @click="emit('toggleModalInner')"
    >
      <NuxtIcon
        class="text-auth-texts/80"
        name="arrows/arrow_left"
      />
      <span class="text-auth-texts font-semibold text-base">
        {{ $t('deposit.general.go_back') }}
      </span>
    </div>

    <div class="check-circle mx-auto mt-3">
      <svg
        aria-hidden="true"
        class="stroke-success"
        fill="none"
        height="30"
        viewBox="0 0 16 16"
        width="30"
      >
        <path
          d="M3 8.5l3.2 3.2L13 5"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2.2"
        />
      </svg>
    </div>

    <h5 class="text-auth-texts font-bold text-xl mt-4 mb-2">
      {{ $t('account.wallet.deposit_approved.title') }}
    </h5>

    <p class="text-auth-texts/80 mb-3">
      {{
        $t('account.wallet.deposit_approved.subtitle', {
          amount: amountLabel,
        })
      }}
    </p>

    <p
      v-if="differentAccount"
      class="text-auth-texts/60 text-sm px-2 mb-4"
    >
      {{ $t('account.wallet.deposit_approved.different_account_notice') }}
    </p>

    <div
      v-if="bankAccountLabel"
      class="registered-account text-left"
    >
      <p class="badge">
        ✓
        {{
          isNewAccount
            ? $t('account.wallet.deposit_approved.account_badge')
            : $t('account.wallet.deposit_approved.account_badge_existing')
        }}
      </p>
      <p class="bank-name">{{ bankAccountLabel }}</p>
      <p class="account-line">{{ agencyAccountLabel }}</p>
    </div>

    <button
      class="btn-conclude mt-6"
      type="button"
      @click="emit('toggleModalInner')"
    >
      {{ $t('account.wallet.deposit_approved.conclude') }}
    </button>
  </div>
</template>

<style scoped lang="scss">
.deposit-approved {
  .check-circle {
    @apply flex items-center justify-center rounded-full bg-success/10;
    width: 76px;
    height: 76px;
  }

  .registered-account {
    @apply border border-solid border-success rounded-lg px-4 py-3 my-2;

    .badge {
      @apply text-success text-sm font-semibold mb-2;
    }
    .bank-name {
      @apply text-auth-texts font-semibold text-base;
    }
    .account-line {
      @apply text-auth-texts/60 text-sm;
    }
  }

  .btn-conclude {
    @apply rounded-md font-medium text-lg bg-auth-button-deposit-bg text-auth-button-deposit-text w-full px-3 py-3 cursor-pointer;
  }
}
</style>
